import { render, staticRenderFns } from "./QuickBrandCreate.vue?vue&type=template&id=86ff3e9a&scoped=true"
import script from "./QuickBrandCreate.vue?vue&type=script&lang=js"
export * from "./QuickBrandCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickBrandCreate.vue?vue&type=style&index=0&id=86ff3e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff3e9a",
  null
  
)

export default component.exports